import { Box, Typography, Paper, Tabs, Tab } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import EmailQueueStats from './EmailQueueStats';
import EmailQueueList from './EmailQueueList';

/**
 * Email Queue Management Page
 * Combines statistics and queue list in tabbed interface
 */
export default function EmailQueuePage() {
  const { t } = useTranslation('admin');
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        {t('emailQueue.title')}
      </Typography>

      <Typography variant="body1" color="text.secondary" paragraph>
        {t('emailQueue.description')}
      </Typography>

      <Paper sx={{ mt: 3 }}>
        <Tabs value={activeTab} onChange={(_, newValue) => setActiveTab(newValue)}>
          <Tab label={t('emailQueue.tabs.queue')} />
          <Tab label={t('emailQueue.tabs.statistics')} />
        </Tabs>

        <Box sx={{ p: 3 }}>
          {activeTab === 0 && <EmailQueueList />}
          {activeTab === 1 && <EmailQueueStats />}
        </Box>
      </Paper>
    </Box>
  );
}
